export class Queue<T> {
  private readonly map: Map<number, T>;

  private startIndex: number;
  private endIndex: number;

  constructor() {
    this.map = new Map<number, T>();
    this.startIndex = this.endIndex = 0;
  }

  get size(): number {
    return this.endIndex - this.startIndex;
  }

  get isEmpty(): boolean {
    return this.size === 0;
  }

  get all(): T[] {
    return Array.from(this.map.values());
  }

  enqueue(t: T) {
    this.map.set(this.endIndex, t);
    this.endIndex++;
  }

  dequeue(): T | undefined {
    if (this.isEmpty)
      return undefined;
    let result = this.map.get(this.startIndex);
    this.map.delete(this.startIndex);
    this.startIndex++;
    return result;
  }

  clear() {
    this.map.clear();
    this.startIndex = this.endIndex = 0;
  }

}
